import { createUrlStore } from "../../../utils/createUrlStore.ts";
import type { ModelCompatibleTool } from "../../Board/types.ts";
import { CREATE_DEFAULT_TOOL } from "../../Board/Workspaces/constants.ts";
import { STYLE_MODEL_TYPE } from "../../constants.ts";
import type { ModelType } from "../../types.ts";

export type BoardModelPickerState = {
  isOpen: boolean | null;
  initialSelectedModelUuid: string | undefined;
  modelType: ModelType;
  tool: ModelCompatibleTool;
};

type BoardModelPickerActions = {
  setState: (params: Partial<BoardModelPickerState>) => void;
  reset: () => void;
};

export const boardModelPickerStore = createUrlStore<
  BoardModelPickerState,
  BoardModelPickerActions
>(
  {
    isOpen: false,
    initialSelectedModelUuid: undefined,
    modelType: STYLE_MODEL_TYPE,
    tool: CREATE_DEFAULT_TOOL,
  },
  {
    isOpen: {
      paramName: "modelPickerOpen",
      serialize: (value) => value?.toString() ?? "",
      deserialize: (value) => value === "true",
    },
  },
  ({ set }) => ({
    setState: (params: Partial<BoardModelPickerState>) => {
      set(params);
    },
    reset: () => {
      set({
        isOpen: null,
        initialSelectedModelUuid: undefined,
        modelType: STYLE_MODEL_TYPE,
        tool: CREATE_DEFAULT_TOOL,
      });
    },
  }),
);
